import { PublicKeyRepository } from '@/Domain/XmlOffer/Encrypter/PublicKeyRepository'
import { Province } from '@/Domain/Procedures'
import { PublicKey } from '@/Domain/XmlOffer/Encrypter'

const baseKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1aXxfveOfXpxgDVV9lS0
yUG44Ww3SjvNbutW3fAB//wfNxC3TyEzDWIjBxCv9uwd0rLNAMrmcNq5jsXNA+db
B6Av/o6p+iEjLy1L5PdUwLgEbR8ZppLYcMVVPj37da3h5xa3iaBDzhhOJ9M1icm6
S62QfYXRH5OMs9NGyVWSW1NGwMyrzKuQGaoCTsAoQl0xeHRRpH2jEhfXfVvevyee
Tpgd1tA+8bPzGr35luJMPgh2Ad0Mj7i2R+Nv91OtxFgYqYi+g3MiBe0aYphU8UIm
HLBFpLmM1xM6Rplc7CeS4VPadUVWF3jz3h0keGaOTS9RwMLjjkjm435nq/r74NHI
NQIDAQAB
-----END PUBLIC KEY-----`
const storedKeys: { [key: string]: string[]; } = {
  15: [baseKey, baseKey, baseKey, baseKey, baseKey, baseKey],
  32: [baseKey, baseKey, baseKey, baseKey, baseKey, baseKey],
  27: [baseKey, baseKey, baseKey, baseKey, baseKey],
  36: [baseKey, baseKey, baseKey]
}
async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
export class InMemoryPublicKeyRepository implements PublicKeyRepository {
  async byProvince (province: Province): Promise<PublicKey[]> {
    await wait(500)
    const keys = storedKeys[province]
    const result = keys.map((current, index) => {
      return new PublicKey(index, current)
    })
    return result
  }
}
